import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { BLOCK_NODE, FIELD_NODE } from '../../../constants/formNode';
import ContributeFormNodeRoot from './Root/ContributeFormNodeRoot';
import ContributeFormNodeField from './Field/ContributeFormNodeField';
import ContributeFormNodeBlock from './Block/ContributeFormNodeBlock';
import HiddenBoxesContext from '../ContributeFormTemplate/HiddenBoxesContext';
import arePropsEqual from '../../../helpers/arePropsEqual';

const ContributeFormNode = memo(({ node, ...props }) => {
  const hiddenBoxes = useContext(HiddenBoxesContext);
  const path = `${props.parentFieldName || ''}${node.id}`;
  const isHidden = hiddenBoxes.includes(path);

  if (isHidden) {
    return null;
  }

  switch (node.nodeType) {
    case 'root':
      return <ContributeFormNodeRoot node={node} {...props} />;
    case BLOCK_NODE:
      return <ContributeFormNodeBlock node={node} {...props} />;
    case FIELD_NODE:
      return <ContributeFormNodeField node={node} {...props} />;
    default:
      return null;
  }
}, arePropsEqual);

ContributeFormNode.displayName = 'ContributeFormNode';

ContributeFormNode.propTypes = {
  node: PropTypes.object,
  parentFieldName: PropTypes.string,
};

export default ContributeFormNode;
